import type { FileUploadTarget } from '@/server/services/userUpload'

import RPC from '@/client/rpc'

import { xhrUpload } from './helpers'

export default async function uploadFile({
  file,
  fileType,
  target,
  onProgress,
}: {
  file: File
  fileType: string
  target: FileUploadTarget
  onProgress?: (progress: number) => void
}): Promise<{ downloadUrl: string; userUploadId: number }> {
  const { downloadUrl, uploadUrl, userUploadId } = await RPC.requestUserUpload({
    file: {
      name: file.name,
      mime: fileType,
    },
    target,
  })

  await xhrUpload({
    url: uploadUrl,
    file,
    onProgress,
  })

  await RPC.completeUserUpload({
    userUploadId,
  })

  return { downloadUrl, userUploadId }
}
